import { useRoute } from 'wouter'
import { useDocumentState } from '@/state'
import { Slider } from '@/components/ui/slider'
import { useEffect } from 'react'

export const DocumentZoom = () => {
  const [isPrintPage] = useRoute('/p/:projectId/document/:documentId/print')

  const zoom = useDocumentState((state) => state.zoom)
  const setZoom = useDocumentState((state) => state.setZoom)
  const defaultZoom = useDocumentState((state) => state.defaultZoom)

  useEffect(() => {
    if (isPrintPage) {
      setZoom(100)
    }
  }, [isPrintPage, setZoom, defaultZoom])

  return (
    !isPrintPage && (
      <div className="absolute w-40 p-2 bottom-4 right-4 flex items-center flex-col bg-slate-50/50 rounded-md">
        <label id="zoom-label" className="text-sm mb-1">
          {Math.round(zoom - defaultZoom)}%
        </label>
        <Slider
          aria-describedby="zoom-label"
          min={50}
          max={200}
          step={5}
          value={[zoom - defaultZoom]}
          defaultValue={[100]}
          onValueChange={([val]) => setZoom(val + defaultZoom)}
        />
      </div>
    )
  )
}
